module.exports = __webpack_public_path__ + "static/media/bg-timer.2c524d4d.png";